export const VERSION = 'v20210513'

// 배포 시에는 버전을 명시한다. 이 버전은 배포시의 API gateway의 stage와 일치하게 된다.
export const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? `https://api.8-codes.com/${VERSION}`
    : 'http://localhost:3000'
// export const API_ENDPOINT = "http://localhost:3000";

// Undraw 컬러 #60a5fa